const SUFFIX = 'Verbum'

// Ordem importa: a primeira regra que casar vence. Textos em linguagem simples, iguais aos do menu e dos títulos das telas.
const RULES: Array<[RegExp, string]> = [
  [/^\/login$/, 'Entrar'],
  [/^\/acesso\/convite\/resultado$/, 'Resultado do acesso'],
  [/^\/acesso\/convite$/, 'Concluir acesso'],
  [/^\/(forgot-password|reset-password|accept-invitation)$/, 'Recuperar acesso'],
  [/^\/dashboard$/, 'Início'],
  [/^\/board$/, 'Avisos'],
  [/^\/communications\/create$/, 'Novo comunicado'],
  [/^\/communications\/[^/]+\/edit$/, 'Editar comunicado'],
  [/^\/communications\/[^/]+$/, 'Comunicado'],
  [/^\/communications$/, 'Comunicados'],
  [/^\/communication-templates$/, 'Modelos de comunicado'],
  [/^\/calendar\/editorial$/, 'Calendário editorial'],
  [/^\/calendar\/create$/, 'Novo evento'],
  [/^\/calendar\/[^/]+\/edit$/, 'Editar evento'],
  [/^\/calendar\/[^/]+$/, 'Evento'],
  [/^\/calendar$/, 'Calendário'],
  [/^\/readership$/, 'Painel de leituras'],
  [/^\/analytics/, 'Relatórios'],
  [/^\/whatsapp\/[^/]+\/[^/]+$/, 'Detalhe do envio'],
  [/^\/whatsapp$/, 'Envios do WhatsApp'],
  [/^\/notifications$/, 'Notificações'],
  [/^\/search$/, 'Busca'],
  [/^\/profile$/, 'Meu perfil'],
  [/^\/settings$/, 'Configurações'],
  [/^\/users\/create$/, 'Convidar usuário'],
  [/^\/users\/[^/]+\/edit$/, 'Editar usuário'],
  [/^\/users$/, 'Usuários'],
  [/^\/stores\/create$/, 'Nova loja'],
  [/^\/stores\/[^/]+(\/edit)?$/, 'Loja'],
  [/^\/stores$/, 'Lojas'],
  [/^\/departments\/create$/, 'Novo departamento'],
  [/^\/departments\/[^/]+(\/edit)?$/, 'Departamento'],
  [/^\/departments$/, 'Departamentos'],
  [/^\/business-hours/, 'Horários comerciais'],
  [/^\/tenant-branding$/, 'Identidade visual'],
  [/^\/tenant-smtp$/, 'Configuração de e-mail'],
  [/^\/audit$/, 'Histórico de ações'],
]

export function pageTitle(pathname: string) {
  const path = pathname.replace(/\/+$/, '') || '/'
  const title = RULES.find(([pattern]) => pattern.test(path))?.[1]
  return title ? `${title} · ${SUFFIX}` : `${SUFFIX} · Comunicação interna`
}
